import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Label, ChoiceGroup } from '@bingads-webui-react/fabric-control';
import C from '../constants';

const AspectRatioChoiceGroup = (props) => {
  const {
    i18n,
    aspectRatioOption,
    onChange,
  } = props;

  const aspectRatioOptions = C.getAspectRatioOptions(i18n);

  return (
    <Stack horizontal className="aspect-ratio-choice-group-stack">
      <Label>{i18n.getString('AspectRatioChoiceGroup_Description')}</Label>
      <ChoiceGroup
        className="aspect-ratio-choice-group"
        defaultSelectedKey={aspectRatioOption}
        options={aspectRatioOptions}
        onChange={onChange}
      />
    </Stack>
  );
};

AspectRatioChoiceGroup.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  aspectRatioOption: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AspectRatioChoiceGroup;
